export default {
  methods: {
    getEstablecimientos() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      var url = window.global.url + "establecimientos";
      app.preloader.show();
      app.request.json(url, function (response) {
        if (response.status == 'success') {
          // console.log(response);
          var establecimientos = response.establecimientos;
          establecimientos.forEach(function (establecimiento, i) {
            $('[name="establecimientos"]').append($('<option>').text(establecimiento.nombre).attr('value', establecimiento.id_establecimiento));
          });
          $('[name="establecimientos"] option[value="0"]').prop('selected', true);
          app.preloader.hide();
        }
      });
    },

    getFormasDePago() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      var url = window.global.url + "caja/formas-de-pago";
      app.preloader.show();
      app.request.json(url, function (response) {
        if (response.status == 'success') {
          // console.log(response);
          var formasDePago = response.formas_de_pago;
          formasDePago.forEach(function (formas_de_pago, i) {
            $('[name="formas-de-pago"]').append($('<option>').text(formas_de_pago.fpnombre).attr('value', formas_de_pago.fpid));
          });
          $('[name="formas-de-pago"] option[value="0"]').prop('selected', true);
          app.preloader.hide();
        }
      });
    },

    crearPago() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      var url = window.global.url + "caja/movimientos";
      var smartSelectEstablecimientos = app.smartSelect.get('.smart-select-establecimientos');
      var smartSelectFormasDePago = app.smartSelect.get('.smart-select-formas-de-pago');
      var idEstablecimiento = smartSelectEstablecimientos.getValue();
      var idFormaDePago = smartSelectFormasDePago.getValue();
      var fechaMovimiento = $('input[name="fecha-movimiento"]').val();
      var montoTotal = $('input[type=number][name="monto-total"]').val().trim();
      var montoDiferencia = $('input[type=number][name="monto-diferencia"]').val().trim();
      var detalle = $('textarea[name="detalle"]').val().trim();
      var movimiento = {
        "usu_registra": usuario.id_usuario,
        "id_establecimiento": idEstablecimiento,
        "tipo_pago": idFormaDePago,
        "tipo_mov": "I",
        "fecha_mov": fechaMovimiento,
        "montototal": montoTotal,
        "montodif": montoDiferencia,
        "detalle": detalle
      };
      app.preloader.show();
      app.request({
        headers: {
          'Authorization': localStorage.getItem('token')
        },
        url: url,
        dataType: 'json',
        contentType: "application/json",
        method: 'POST',
        data: movimiento,
        statusCode: {
          404: function (xhr) {
            console.log("URL not found");
          },
          400: function (xhr) {
            console.log("Bad request. Some of the inputs provided to the request aren't valid.");
          },
          401: function (xhr) {
            console.log("Not authenticated. The user session isn't valid.");
          },
          403: function (xhr) {
            console.log("The user isn't authorized to perform the specified request.");
            app.views.main.router.navigate({
              path: '/'
            });
          },
          500: function (xhr) {
            console.log("Internal server error. Additional details will be contained on the server logs.");
          },
          201: function (xhr) {
            console.log("The requested resource has been created.");
          }
        },
        success: function (data, status, xhr) {
          // console.log(data);
          if (data.status == 'success') {
            app.dialog.alert("Pago creado con éxito.");
            self.reiniciarCampos();
            self.validarCampos();
            self.getUltimosMovimientos(idEstablecimiento);
          } else {
            app.dialog.alert("Error al crear pago.");
            app.preloader.hide();
          }

          app.preloader.hide();
        },
        error: function (xhr, status) {
          app.preloader.hide();
          console.log(xhr);
          console.log(JSON.stringify(xhr));
          console.log(status);
          app.dialog.alert("Error al crear pago.");
        }
      });
    },

    getUltimosMovimientos(idEstablecimiento) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var usuario = JSON.parse(localStorage.getItem('usuario'));
      var url = window.global.url + "caja/movimientos/ultimos/" + idEstablecimiento;
      var table = $('.data-table-ultimos-movimientos table').find('tbody');
      $('.mensaje-tabla-vacia').addClass('display-none');
      app.preloader.show();
      table.empty();

      if (idEstablecimiento != 0) {
        app.request({
          headers: {
            'Authorization': localStorage.getItem('token')
          },
          url: url,
          method: 'GET',
          dataType: 'json',
          contentType: "application/json",
          statusCode: {
            404: function (xhr) {
              console.log("URL not found");
            },
            400: function (xhr) {
              console.log("Bad request. Some of the inputs provided to the request aren't valid.");
            },
            401: function (xhr) {
              console.log("Not authenticated. The user session isn't valid.");
            },
            403: function (xhr) {
              console.log("The user isn't authorized to perform the specified request.");
              app.views.main.router.navigate({
                path: '/'
              });
            },
            500: function (xhr) {
              console.log("Internal server error. Additional details will be contained on the server logs.");
            },
            201: function (xhr) {
              console.log("The requested resource has been created.");
            }
          },
          success: function (data, status, xhr) {
            if (data.status == 'success') {
              // console.log(response);
              let ultimosMovimientos = data.caja_ultimos_movimientos;

              if (ultimosMovimientos.length > 0) {
                for (let i = 0; i < ultimosMovimientos.length; i++) {
                  const movimiento = ultimosMovimientos[i];
                  var row = table.append($('<tr>'));
                  row.append($('<td class="label-cell">').text(self.formatDate(movimiento.fecha_mov)));
                  row.append($('<td class="label-cell">').text(movimiento.nombre));
                  row.append($('<td class="label-cell">').text(movimiento.fpnombre));
                  row.append($('<td class="numeric-cell">').text('$ ' + movimiento.montototal));
                  row.append($('<td class="numeric-cell">').text('$ ' + movimiento.montodif));
                  row.append($('<td class="label-cell">').text(movimiento.detalle));
                }
              } else {
                $('.mensaje-tabla-vacia').text('El establecimiento no tiene movimientos recientes.');
                $('.mensaje-tabla-vacia').removeClass('display-none');
              }

              app.preloader.hide();
            }
          },
          error: function (xhr, status) {
            app.preloader.hide();
            console.log(xhr);
            console.log(JSON.stringify(xhr));
            console.log(status);
          }
        });
      } else {
        app.preloader.hide();
        $('.mensaje-tabla-vacia').text('Selecciona un establecimiento para ver los últimos movimientos.');
        $('.mensaje-tabla-vacia').removeClass('display-none');
      }
    },

    validarCampos() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var montoTotal = $('input[type=number][name="monto-total"]').val().trim();
      var montoPagado = $('input[type=number][name="monto-diferencia"]').val().trim();
      var smartSelectEstablecimientos = app.smartSelect.get('.smart-select-establecimientos');
      var smartSelectFormasDePago = app.smartSelect.get('.smart-select-formas-de-pago');
      var selectEstablecimiento = smartSelectEstablecimientos.getValue();
      var selectFormaDePago = smartSelectFormasDePago.getValue();

      if (montoTotal.length == 0 || montoPagado.length == 0 || selectEstablecimiento == 0 || selectFormaDePago == 0) {
        $('.crear-pago-button').addClass('disabled');
        return false;
      }

      $('.crear-pago-button').removeClass('disabled');
      return true;
    },

    reiniciarCampos() {
      var self = this;
      var app = self.$app;
      var $ = self.$; // var smartSelectEstablecimientos = app.smartSelect.get('.smart-select-establecimientos');
      // var smartSelectFormasDePago = app.smartSelect.get('.smart-select-formas-de-pago');
      // smartSelectEstablecimientos.setValue(0);
      // smartSelectFormasDePago.setValue(0);

      $('input[type=number][name="monto-total"]').val("");
      $('input[type=number][name="monto-diferencia"]').val("0");
      $('textarea[name="detalle"]').val("");
    },

    setDateToday() {
      var self = this;
      var app = self.$app;
      var $ = self.$;

      Date.prototype.toDateInputValue = function () {
        var local = new Date(this);
        local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
        return local.toJSON().slice(0, 10);
      };

      $('input[name="fecha-movimiento"]').val(new Date().toDateInputValue());
    },

    formatDate(fecha) {
      var date = new Date(fecha);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
        month = '0' + month;
      }

      var formattedDate = day + '-' + month + '-' + year;
      return formattedDate;
    }

  },
  on: {
    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      self.getEstablecimientos();
      self.getFormasDePago();
      self.setDateToday();
      var dataTableUltimosMovimientos = app.dataTable.create({
        el: '.data-table-ultimos-movimientos'
      });
      $('input[type=number][name=monto-total], input[type=number][name=monto-diferencia]').on('input', function () {
        self.validarCampos();
      });
      $('.page[data-name="superadmin-caja"] select[name="establecimientos"], select[name="formas-de-pago"]').on('change', function () {
        self.validarCampos();
      });
      $('.page[data-name="superadmin-caja"] select[name="establecimientos"]').on('change', function () {
        let idEstablecimiento = app.smartSelect.get('.smart-select-establecimientos').getValue();
        self.getUltimosMovimientos(idEstablecimiento);
      });
      $('.crear-pago-button').on('click', function () {
        self.crearPago();
      });
    }

  },
  id: '3d988c0891',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=superadmin-caja><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class=title>Caja</div><div class=right></div></div></div><div class=page-content><div class="row justify-content-center"><div class="col-100 medium-100 large-50"><div class=block-title>Ingresar pago</div><div class="list no-hairlines-md"><ul><li><a class="item-link smart-select smart-select-establecimientos smart-select-init" data-searchbar=true data-searchbar-placeholder="Buscar establecimiento" data-open-in=popup data-popup-close-link-text=Cerrar><select name=establecimientos required validate><option value=0>Seleccionar</option></select><div class=item-content><div class=item-inner><div class=item-title>Establecimiento</div></div></div></a></li><li><a class="item-link smart-select smart-select-formas-de-pago smart-select-init" data-open-in=popup data-popup-close-link-text=Cerrar><select name=formas-de-pago required validate><option value=0>Seleccionar</option></select><div class=item-content><div class=item-inner><div class=item-title>Forma de pago</div></div></div></a></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Fecha</div><div class=item-input-wrap><input type=date name=fecha-movimiento placeholder="Seleccionar fecha"></div></div></li><li><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Monto total</div><div class=item-input-wrap><input type=number name=monto-total placeholder="Monto total" required validate></div></div></div></li><li><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Monto diferencia</div><div class=item-input-wrap><input type=number name=monto-diferencia value=0 placeholder="Monto diferencia" required validate></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Detalle</div><div class=item-input-wrap><textarea class=resizable name=detalle placeholder="Detalle (opcional)"></textarea></div></div></li></ul></div><div class=block><p class=row><a href=# class="col button button-round button-fill crear-pago-button disabled">Crear Pago</a></p></div></div></div><div class=row><div class=col-100><div class=block-title>Últimos movimientos</div><div class="data-table data-table-ultimos-movimientos card"><table><thead><tr><th class=label-cell>Fecha</th><th class=label-cell>Usuario</th><th class=label-cell>Forma Pago</th><th class=numeric-cell>Monto</th><th class=numeric-cell>Debe</th><th class=label-cell>Detalle</th></tr></thead><tbody></tbody></table><h3 class="text-align-center mensaje-tabla-vacia display-none"></h3></div></div></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};